'use client';

export default function JsonLdOrganization() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://insulacharter.it/#organization',
    name: 'InsulaCharter',
    url: 'https://insulacharter.it',
    logo: 'https://insulacharter.it/logo.png',
    image: 'https://insulacharter.it/og-image.jpg',
    description: 'Piattaforma di noleggio imbarcazioni in Sardegna. Yacht, catamarani, gommoni, barche a vela e charter con skipper.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Alghero',
      addressRegion: 'SS',
      addressCountry: 'IT',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 40.5586,
      longitude: 8.3190,
    },
    areaServed: {
      '@type': 'Place',
      name: 'Sardegna, Italia',
    },
    priceRange: '€€-€€€€',
    sameAs: [
      'https://www.facebook.com/insulacharter',
      'https://www.instagram.com/insulacharter',
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
